import styled from 'styled-components'
import { desktopBreakpoint, wideScreenBreakpoint } from 'react-components'
import { ButtonBack, ButtonNext } from 'pure-react-carousel'

export const ControlsContainer = styled.div<{
    $desktopTop: string
    $desktopRight: string
    $wideTop: string
    $wideRight: string
}>(
    ({ theme, $desktopTop, $desktopRight, $wideTop, $wideRight }) => `
      display: none;

      @media only screen and (min-width: ${desktopBreakpoint.min}px) {
          display: flex;
          gap: ${theme.spacing.medium};
          position: absolute;
          top: ${$desktopTop};
          right: ${$desktopRight};
      }

      @media only screen and (min-width: ${wideScreenBreakpoint.min}px) {
          top: ${$wideTop};
          right: ${$wideRight};
      }
    `,
)

export const CarouselControlButton = styled.button<{ disabled?: boolean }>(
    ({ theme, disabled }) => `
      display: flex;
      cursor: ${disabled ? 'default' : 'pointer'};
      background-color: ${theme.colors.white};
      border-radius: 50%;
      align-items: center;
      justify-content: center;
      box-shadow: 0 0.6875rem 0.9375rem 0 #00000014,
                  0 0.5625rem 2.875rem 0 #0000000A,
                  0 1.5rem 2.375rem 0 #0000000F;
      opacity: ${disabled ? 0.5 : 1};
      transition: opacity 200ms ease-in;
      border: none;
      pointer-events: ${disabled ? 'none' : 'auto'};

      &:hover {
          opacity: ${disabled ? 0.5 : 0.8};
      }

      @media only screen and (min-width: ${desktopBreakpoint.min}px) {
          padding: ${theme.spacing.xSmall};
      }
    `,
)

export const PrevButton = styled(CarouselControlButton).attrs({ as: ButtonBack })``
export const NextButton = styled(CarouselControlButton).attrs({ as: ButtonNext })``

export const ButtonIcon = styled.img`
    height: 20px;
    width: 20px;
`
